export default __webpack_public_path__ + "static/media/sbcc.977f301b.png";